import toLowerKebabCase from '~/utilities/toLowerKebabCase';

export type NewCarVariant = 'Generic' | 'Make' | 'MakeModel';

type NewCarMetaData = { make?: string; model?: string };

export function getNewCarVariant(
  metaData: NewCarMetaData | undefined
): NewCarVariant {
  if (metaData?.make && metaData?.model) return 'MakeModel';
  if (metaData?.make) return 'Make';

  return 'Generic';
}

export function getNewCarHref(metaData: NewCarMetaData | undefined): string {
  if (metaData?.make && metaData?.model)
    return `/new/${toLowerKebabCase(metaData.make)}/${toLowerKebabCase(
      metaData.model
    )}`;
  if (metaData?.make) return `/new/${toLowerKebabCase(metaData.make)}`;

  return '/new';
}
